import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const submitInvitation = (payload) =>
  api.post("/invitations", payload).then((r) => r.data);

export const submitPrivateInquiry = (payload) =>
  api.post("/private-inquiries", payload).then((r) => r.data);

export const fetchPieces = () => api.get("/jewelry/pieces").then((r) => r.data);

export const fetchPiece = (slug) => api.get(`/jewelry/pieces/${slug}`).then((r) => r.data);

export const createCheckout = (slug) =>
  api
    .post("/payments/checkout", { slug, origin_url: window.location.origin })
    .then((r) => r.data);

export const fetchPaymentStatus = (sessionId) =>
  api.get(`/payments/status/${sessionId}`).then((r) => r.data);
